import { useTranslation } from "react-i18next";
import { useUser } from "./useUser";
import useOrganisationDetailsQuery from "@/api/query/useOrganisationDetailsQuery";

export interface ProjectFieldLabels {
  categoryLabel: string;
  typeLabel: string;
  phaseLabel: string;
  workstreamLabel: string;
  priorityLabel: string;
  rawLabels: {
    category?: string;
    type?: string;
    phase?: string;
    workstream?: string;
    priority?: string;
  };
}

export function useProjectFieldLabels(): ProjectFieldLabels {
  const { t } = useTranslation();
  const { organisationId } = useUser();
  const { data: orgData } = useOrganisationDetailsQuery(organisationId, Boolean(organisationId));

  const rawLabels = orgData?.data?.data?.projectFieldLabels || {};

  return {
    categoryLabel: rawLabels.category?.trim() || t("Project Category"),
    typeLabel: rawLabels.type?.trim() || t("Project Type"),
    phaseLabel: rawLabels.phase?.trim() || t("Project Phase"),
    workstreamLabel: rawLabels.workstream?.trim() || t("workstream_theme") || t("Domain", "Domain"),
    priorityLabel: rawLabels.priority?.trim() || t("Project Priority"),
    rawLabels,
  };
}

export default useProjectFieldLabels;
